<template>
  <WdsAvatarLabel :path="avatarPath" truncated sm>
    <template #subText>
      <WdsText primary>
        {{ column?.name ?? '' }}
      </WdsText>
    </template>
  </WdsAvatarLabel>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsAvatarLabel, WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { getAvatarPath } from '@/utils/avatar'

const frag = graphql(`
  fragment CompanyNameAvatarColumn on Company {
    id
    name
    avatar
  }
`)

const props = defineProps<{ row: FragmentType<typeof frag> }>()
const column = computed(() => useFragment(frag, props.row))

const avatarPath = computed(() => getAvatarPath(column.value.avatar, column.value.id))
</script>
